import React, { createContext, useEffect, useReducer, useRef } from 'react';
import { initialState, setDarkMode, themeReducer } from '@reducers/themeReducer';
import { getValueFromLocalStorage, setValueToLocalStorage } from '@utils/localStorage';

const THEME_STORAGE_KEY = 'isDarkMode_v2';

export const ThemeContext = createContext({
  themeState: {
    isDarkMode: true,
  },
  themeDispatch: () => {},
});

export const ThemeProvider = ({ children }) => {
  const [themeState, themeDispatch] = useReducer(themeReducer, initialState);

  const { isDarkMode } = themeState;
  const hasLoadedTheme = useRef(false);

  useEffect(() => {
    // 기존 isDarkMode 키는 무시하고, 값이 없으면 다크모드로 시작한다.
    window.localStorage.removeItem('isDarkMode');
    const localStorageTheme = getValueFromLocalStorage(THEME_STORAGE_KEY);
    if (localStorageTheme === null) {
      themeDispatch(setDarkMode(true));
    } else {
      themeDispatch(setDarkMode(localStorageTheme));
    }
  }, []);

  useEffect(() => {
    // 첫 실행은 저장값을 읽기 전의 초기 상태라 건너뛴다. data-theme은 gatsby-ssr.js 인라인 스크립트가 이미 붙였다.
    if (!hasLoadedTheme.current) {
      hasLoadedTheme.current = true;
      return;
    }
    setValueToLocalStorage(THEME_STORAGE_KEY, isDarkMode);
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  return <ThemeContext.Provider value={{ themeState, themeDispatch }}>{children}</ThemeContext.Provider>;
};
